import { API_DOMAIN } from "./Backend";

/** 将相对媒体地址补全为可访问的绝对 URL（OSS 完整地址原样返回） */
export function resolveAppMediaUrl(
  url: string | null | undefined
): string | undefined {
  const trimmed = url?.trim() ?? "";
  if (!trimmed) {
    return undefined;
  }
  if (trimmed.startsWith("blob:")) {
    return trimmed;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  if (trimmed.startsWith("/")) {
    if (!API_DOMAIN) {
      return trimmed;
    }
    return `${API_DOMAIN.replace(/\/+$/, "")}${trimmed}`;
  }
  return trimmed;
}

/** 写入资料库的头像地址：去掉 API 域名前缀，OSS 完整地址原样保留 */
export function toPersistableAvatarUrl(url: string | null | undefined): string {
  const trimmed = url?.trim() ?? "";
  if (!trimmed || trimmed.startsWith("blob:")) {
    return "";
  }
  const domain = API_DOMAIN.replace(/\/+$/, "");
  if (domain && trimmed.startsWith(domain)) {
    const path = trimmed.slice(domain.length);
    return path.startsWith("/") ? path : `/${path}`;
  }
  return trimmed;
}
